import { UI_PERMISSION } from "@/core/utils/access/permissionConstants"
import { useFeatureFlag } from "@/hooks/useFeatureFlag"
import usePermissions from "@/hooks/userPermission"

/**
 * Print module access guard.
 *
 * Returns true only when BOTH conditions are met:
 *  1. The "enable-print-module" feature flag is ON in the current environment.
 *  2. The authenticated user has the UI_PRINT_CREATE backend permission.
 */
export const usePrintAccess = (): boolean => {
  const isFlagEnabled = useFeatureFlag("enable-print-module")
  const { hasAny } = usePermissions()
  return isFlagEnabled && hasAny(UI_PERMISSION.UI_PRINT_CREATE)
}
